import { Grid, IconButton, Tooltip } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { MdArrowBack } from 'react-icons/md'
import { GlobalContext } from '../../../App'
import Programa from '../../../components/Programa/Programa'
import Edicao from './Edicao'
import PrimeTable from '../../../components/PrimeTable'
import ModalSelecionaPontoVenda from '../pontoDeVenda/modal/modalSelecionaPontoVenda'
import { BsPlus, BsShopWindow } from 'react-icons/bs'
import { useModal } from '../../../components/Utils/UseModal'
import ModalSelecionaAtendimento from './modalSelecionaAtendimento'
import { metodoPrograma } from '../../../components/api'

export const STATUS_MAP = {
  0: { label: 'Em preparação', color: '#1976d2', background: '#e3f2fd' },
  1: {
    label: 'Pronto para Cobrança',
    color: '#ff9800',
    background: '#fff5e6',
  },
  2: {
    label: 'Pago',
    color: '#02a50a',
    background: '#e2ffe1',
  },
  3: { label: 'Cancelado', color: '#a7a7a7', background: '#f9f9f9' },
}

export function StatusChip({ status }) {
  const info = STATUS_MAP[status]

  if (!info) return status

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '4px 10px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 600,
        width: '100%',
        color: info.color,
        backgroundColor: info.background,
        textAlign: 'center',
      }}
    >
      {info.label}
    </span>
  )
}

const OrcamentoCheckin = () => {
  const { localAtendimento, usuarioLogado } = useContext(GlobalContext)

  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)

  const { lojaPontoVenda } = useContext(GlobalContext)

  const modalSelecionaAtendimento = useModal(ModalSelecionaAtendimento)

  const [openModal, setOpenModal] = useState(!lojaPontoVenda?.idPontoVenda)

  const [pontoVenda, setPontoVenda] = useState({ id: null, qtd: null })

  const voltar = () => {
    setTela('lista')
    setDados(undefined)
  }

  const handleClick = async (linha) => {
    const isRascunho = linha?.[2] === '0'
    const isFinalizado = !isRascunho
    const somenteLeitura =
      isRascunho && Number(linha?.[19]) !== Number(usuarioLogado?.id)

    const { status, dados, itens } = await metodoPrograma(
      'buscaCheckinPorAtendimento',
      {
        idAtendimento: linha?.[0],
        idPaciente: linha?.[1]?.[0]?.[0],
        isFinalizado,
      },
    )
    if (dados !== null && !status) return

    dados[18] = linha?.[18] || ''

    setDados({ linha: dados, itens, isFinalizado, isRascunho, somenteLeitura })
    setTela('opcoes')
  }

  const crirarCheckinPorAtendimento = async () => {
    const retorno = await modalSelecionaAtendimento()
    if (!retorno?.dados) return

    const { dados, itens } = retorno

    dados[18] = dados?.[18] || ''

    setDados({
      linha: dados,
      itens,
      isFinalizado: false,
      isRascunho: false,
      somenteLeitura: false,
    })
    setTela('opcoes')
  }

  useEffect(() => {
    switch (tela) {
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <span>
              <IconButton onClick={voltar}>
                <MdArrowBack />
              </IconButton>
            </span>
          </Tooltip>,
        )
        break
      default:
        setFerramentas(
          <Tooltip title="Criar checkin por atendimento">
            <span>
              <IconButton onClick={crirarCheckinPorAtendimento}>
                <BsPlus />
              </IconButton>
            </span>
          </Tooltip>,
        )
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])
  const handleCloseModal = (id, qtd) => {
    if (id) {
      if (qtd > 1)
        setFerramentas(
          <>
            <Tooltip title="Alterar Ponto de Venda">
              <span>
                <IconButton onClick={() => setOpenModal(true)}>
                  <BsShopWindow />
                </IconButton>
              </span>
            </Tooltip>
          </>,
        )
      setPontoVenda({ id, qtd })
      setOpenModal(false)
    }
  }
  return (
    <Programa codigo="CtrlOrcamentoCheckin" ferramentas={ferramentas}>
      <ModalSelecionaPontoVenda open={openModal} onClose={handleCloseModal} />
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PrimeTable
              codigo="CtrlOrcamentoCheckin"
              action="lista"
              rows={10}
              habSearch
              parametros={{
                idLocalAtendimento: localAtendimento?.[0],
              }}
              collumnsDate={[3, 4]}
              collumnsDateHour={[5]}
              collumnsCurrency={[6, 7, 8]}
              head={[
                'Proposta',
                'Contratante',
                'Situação',
                'Checkin',
                'Checkout',
                'Inclusão',
                'Total',
                'Pago',
                'Resultado',
              ]}
              line={(item) => [
                item[0],
                item[1][1],
                item?.[2] ? <StatusChip status={item[2]} /> : '',
                item[5],
                item[6],
                item[8],
                item[9],
                item[15],
                item[16],
              ]}
              onRowSelect={handleClick}
            />
          </Grid>
        </Grid>
      ) : (
        <Edicao dados={dados} voltar={voltar} pontoVenda={pontoVenda} />
      )}
    </Programa>
  )
}

export default OrcamentoCheckin
